import React from 'react'

import Icon from '../../../icon/Icon'

import ribbonIcon from './ribbon.png'
import {
  AppBannerRibbonStyled,
  AppBannerRibbonIconStyled,
  AppBannerRibbonIconWrapperStyled,
} from './styled'

export const AppBannerRibbonIcon = ({ lang, theme }) => {
  return (
    <AppBannerRibbonIconWrapperStyled lang={lang} theme={theme}>
      <AppBannerRibbonStyled />
      <AppBannerRibbonIconStyled>
        <Icon src={ribbonIcon} />
      </AppBannerRibbonIconStyled>
    </AppBannerRibbonIconWrapperStyled>
  )
}
